import { BackLink } from '@norges-domstoler/dds-components';
import { BannerInfo } from '../../../Models/Interfaces/Banner/BannerInfo';
import IContent from '@episerver/spa-core/dist/Models/IContent';
import DomstolBanner from './Banner';
import { useLinkClickHandler } from 'react-router-dom';
import { getRelativeUrl } from '../Utils';

export type BreadcrumbAndBannerComponentProps = {
    iContent: IContent;
    parentPageHref?: string;
    parentPageName: string;
    breadcrumbwrappclass?: string;
    heading?: string;
    bannerInfo?: BannerInfo;
};

export const BreadcrumbAndBannerComponent = ({
    parentPageHref = '/',
    bannerInfo,
    iContent,
    heading,
    parentPageName,
    breadcrumbwrappclass,
}: BreadcrumbAndBannerComponentProps) => {
    const linkClickHandler = useLinkClickHandler<HTMLDivElement>(getRelativeUrl(parentPageHref));

    return (
        <>
            {bannerInfo?.bannerName && (
                <DomstolBanner bannerInfo={bannerInfo} iContent={iContent} heading={heading ?? ''} />
            )}
            <div className="container">
                <div className="row">
                    <div className={breadcrumbwrappclass}>
                        <div className="link-width" onClick={linkClickHandler}>
                            <BackLink label={parentPageName} href={parentPageHref} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BreadcrumbAndBannerComponent;
